import styles from './Avatar.module.css';

function initials(name = '') {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0])
    .join('')
    .toUpperCase();
}

export default function Avatar({ name, src, size = 40 }) {
  const style = { width: size, height: size, fontSize: size * 0.4 };
  if (src) {
    return <img className={styles.avatar} src={src} alt={name || ''} style={style} />;
  }
  return (
    <span className={styles.avatar} style={style} aria-label={name}>
      {initials(name)}
    </span>
  );
}
